var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('floor1'),_c('floor2'),_c('floor3_new'),_c('floor6'),_c('floor5')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }